module.exports = __webpack_public_path__ + "img/horizontal_4_6_7005.24a10e70.png";